import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Box from "@material-ui/core/Box";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";

const ContinueButton = withStyles({
  root: {
    boxShadow: "none",
    textTransform: "none",
    fontSize: 15,
    padding: "15px 10px",
    border: "0.5px solid",
    lineHeight: 0.5,
    backgroundColor: "#002D55",
    borderColor: "#002D55",
    color: "#FFFFFF",
    "&:hover": {
      backgroundColor: "#1a90ff",
      borderColor: "#1a90ff",
      boxShadow: "none"
    },
    //"&:active": {
    //  boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)",
    //  backgroundColor: "#002D55",
    //  borderColor: "#002D55"
    //},
    //"&:focus": {
    //  boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)"
    //}
  }
})(Button);

const UploadVideoButton = withStyles({
  root: {
    boxShadow: "none",
    scale: "0.8",
    textTransform: "none",
    fontSize: 15,
    padding: "10px 10px",
    border: "0.5px solid",
    lineHeight: 0.5,
    backgroundColor: "#1a90ff",
    borderColor: "#1a90ff",
    color: "#FFFFFF",
    "&:hover": {
      backgroundColor: "#1a90ff",
      borderColor: "#1a90ff",
      boxShadow: "none"
    },
    //"&:active": {
    //  boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)",
    //  backgroundColor: "#002D55",
    //  borderColor: "#002D55"
    //},
    //"&:focus": {
    //  boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)"
    //}
  }
})(Button);


export default function FlagExerciseForReview() {
  const [state, setState] = React.useState({
    checkedA: true,
    checkedB: true,
    checkedF: true,
    checkedG: true,
  });

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  return (
   <Grid container justify="left">
    <Box borderRadius={32} style={{backgroundColor: "#red"}}>
          <Table style={{width: "100%"}}>
           <TableRow>
             <TableCell container direction="row" justify="center" xs={11} style={{margin: 10, borderBottom: "none"}}>
               <Typography style={{marginBottom: 5}} variant="h7">
                 Upload exercise video for review by a physiotherapist.
               </Typography>
              </TableCell>  
              <TableCell style={{ borderBottom: "none"}}>
               <UploadVideoButton style={{minWidth: 80}} >
                   Upload
               </UploadVideoButton>
             </TableCell>
           </TableRow>
         
          </Table> 
          </Box>
   </Grid>
  );
}

//<FormControlLabel
//        control={<Checkbox icon={<FavoriteBorder />} checkedIcon={<Favorite />} name="checkedH" />}
//        label="Custom icon"
//    />